import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useAddPaymentType } from '../api/addPaymentType';
import { Fields } from '../hooks/usePaymentTypeForm';

import { PaymentTypeForm } from './PaymentTypeForm';

type AddModalProps = {
  initialValues: Fields;
};

export const AddModal = NiceModal.create(({ initialValues }: AddModalProps) => {
  const modal = useModal();

  const { mutate, isLoading } = useAddPaymentType({
    onSuccess: modal.hide,
  });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="Новый тип платежа"
    >
      <PaymentTypeForm
        isLoading={isLoading}
        onSubmit={(params) => mutate({ ...params })}
        initialValues={initialValues}
      />
    </Modal>
  );
});
